// Module
var code = "<div class=\"vui-tab tw-font-semibold\"\n     ng-class=\"$ctrl.getClass()\">\n    <a ng-href=\"{{$ctrl.href && !$ctrl.active ? $ctrl.href : ''}}\"\n       class=\"vui-tab__link\"\n       ng-disabled=\"$ctrl.disabled\"\n       ng-transclude></a>\n</div>\n";
// Exports
module.exports = code;